module.exports = __webpack_public_path__ + "static/img/Clayton_Oliver_mobile.66cab93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clayton_Oliver_mobile.jpg
// module id = RozR
// module chunks = 0